export const en = {
  'campaigns.title': 'Campaigns',
  'campaigns.description': 'Sales, offers for new members, promo codes, bonus days and announcements, each on its own schedule. The website shows what is running now; a promo code works only when someone types it.',
  'campaigns.new': 'New campaign',
  'campaigns.empty': 'No campaigns',
  'campaigns.emptyHint': 'Run a sale, welcome new members with a lower price, or announce news on the website and in the member app.',
  'campaigns.emptyFiltered': 'No campaign matches these filters.',
  'campaigns.create': 'Create campaign',
  'campaigns.untitled': 'Untitled',
  'campaigns.pill.none': 'No campaign on the website',
  'campaigns.pill.live': 'Live on website: {title}',
  'campaigns.pill.announced': 'Announced: {title} · starts {date}',
  'campaigns.filter.kind': 'Type',
  'campaigns.filter.status': 'Status',
  'campaigns.filter.all': 'All',
  'campaigns.filter.SALE': 'Sales',
  'campaigns.filter.NEW_MEMBER': 'New-member offers',
  'campaigns.filter.ANNOUNCEMENT': 'Announcements',
  'campaigns.filter.PROMO_CODE': 'Promo codes',
  'campaigns.filter.BONUS_DAYS': 'Bonus days',
  'campaigns.status.all': 'All',
  'campaigns.status.live': 'Live',
  'campaigns.status.upcoming': 'Upcoming',
  'campaigns.status.ended': 'Ended',
  'campaigns.status.disabled': 'Disabled',
  'campaigns.kind.SALE': 'Sale',
  'campaigns.kind.NEW_MEMBER': 'New-member offer',
  'campaigns.kind.ANNOUNCEMENT': 'Announcement',
  'campaigns.kind.PROMO_CODE': 'Promo code',
  'campaigns.kind.BONUS_DAYS': 'Bonus days',
  'campaigns.announcedFrom': 'announced from {date}',
  'campaigns.duplicate': 'Duplicate',
  'campaigns.sms.open': 'Text it',
  'campaigns.sms.title': 'Text “{title}”',
  'campaigns.sms.description': 'An offer by SMS goes only to members who agreed to offers by SMS, once per campaign, in their language.',
  'campaigns.sms.audience': 'Who gets it',
  'campaigns.sms.audience.ALL': 'Everyone who agreed',
  'campaigns.sms.audience.ACTIVE': 'Members with an active membership',
  'campaigns.sms.audience.LAPSED': 'Members whose membership has ended',
  'campaigns.sms.audience.SEGMENT': 'A segment',
  'campaigns.sms.segment': 'Segment',
  'campaigns.sms.chooseSegment': 'Choose a segment',
  'campaigns.sms.noSegments': 'The gym has no segments yet.',
  'campaigns.sms.buildSegment': 'Build one',
  'campaigns.sms.segmentConsent': 'Only the members of the segment who agreed to offers by SMS get it.',
  'campaigns.sms.segmentDeleted': 'A deleted segment',
  'campaigns.sms.textEn': 'Text in English',
  'campaigns.sms.textKa': 'Text in Georgian',
  'campaigns.sms.parts': '{characters} characters with the gym name and opt-out line · {parts} SMS part(s)',
  'campaigns.sms.reach': '{count} member(s) will get it: {en} in English, {ka} in Georgian.',
  'campaigns.sms.alreadyTexted': '{count} member(s) already have this campaign and are skipped.',
  'campaigns.sms.totalParts': 'About {parts} SMS parts in all, charged from the gym’s smsoffice.ge balance.',
  'campaigns.sms.rules': 'Texts go out between 10:00 and 21:00 gym time; outside those hours they wait. A member who says no before then does not get it.',
  'campaigns.sms.blocker.NO_SMS_ACCOUNT': 'The gym has no working SMS account yet.',
  'campaigns.sms.blocker.NO_OPT_OUT_LINE': 'Enter the opt-out line smsoffice.ge gave your sender; every offer must end with it.',
  'campaigns.sms.openIntegrations': 'Open Integrations',
  'campaigns.sms.send': 'Send to {count}',
  'campaigns.sms.confirmTitle': 'Text {count} member(s) now?',
  'campaigns.sms.confirmDescription': 'About {parts} SMS parts will be charged. A sent text cannot be taken back.',
  'campaigns.sms.confirm': 'Send texts',
  'campaigns.sms.queued': '{count} text(s) queued',
  'campaigns.sms.history': 'Sent before',
  'campaigns.sms.when': 'When',
  'campaigns.sms.by': 'By',
  'campaigns.sms.counts': 'Waiting · sent · failed',
  'campaigns.sms.countsValue': '{queued} · {sent} · {failed}',
  'campaigns.email.open': 'Email it',
  'campaigns.email.title': 'Email “{title}”',
  'campaigns.email.description': 'An offer by email goes only to members who agreed to offers by email, once per campaign, in their language.',
  'campaigns.email.audience': 'Who gets it',
  'campaigns.email.audience.ALL': 'Everyone who agreed',
  'campaigns.email.audience.ACTIVE': 'Members with an active membership',
  'campaigns.email.audience.LAPSED': 'Members whose membership has ended',
  'campaigns.email.audience.SEGMENT': 'A segment',
  'campaigns.email.segment': 'Segment',
  'campaigns.email.chooseSegment': 'Choose a segment',
  'campaigns.email.noSegments': 'The gym has no segments yet.',
  'campaigns.email.buildSegment': 'Build one',
  'campaigns.email.segmentConsent': 'Only the members of the segment who agreed to offers by email get it.',
  'campaigns.email.segmentDeleted': 'A deleted segment',
  'campaigns.email.subjectEn': 'Subject in English',
  'campaigns.email.subjectKa': 'Subject in Georgian',
  'campaigns.email.textEn': 'Email text in English',
  'campaigns.email.textKa': 'Email text in Georgian',
  'campaigns.email.subjectNeeded': 'Give the email a subject in this language, or clear its text.',
  'campaigns.email.footerNote': 'Every email ends with a line saying why the member gets it and a link that stops offers by email.',
  'campaigns.email.reach': '{count} member(s) will get it: {en} in English, {ka} in Georgian.',
  'campaigns.email.alreadyEmailed': '{count} member(s) already have this campaign and are skipped.',
  'campaigns.email.blocker.NO_EMAIL_ACCOUNT': 'The gym’s own email account must be connected and tested first. Offers never go out from Bulk’s sender.',
  'campaigns.email.blocker.PRACTICE_GYM': 'A practice gym never emails offers; its members are made up.',
  'campaigns.email.openIntegrations': 'Open Integrations',
  'campaigns.email.send': 'Send to {count}',
  'campaigns.email.confirmTitle': 'Email {count} member(s) now?',
  'campaigns.email.confirmDescription': 'A sent email cannot be taken back.',
  'campaigns.email.confirm': 'Send emails',
  'campaigns.email.queued': '{count} email(s) queued',
  'campaigns.email.history': 'Sent before',
  'campaigns.email.when': 'When',
  'campaigns.email.subject': 'Subject',
  'campaigns.email.by': 'By',
  'campaigns.email.counts': 'Waiting · sent · failed',
  'campaigns.email.countsValue': '{queued} · {sent} · {failed}',
  'campaigns.duplicated': 'Copy created and left switched off. Set its dates, then switch it on.',
  'campaigns.deleted': 'Campaign deleted',
  'campaigns.switchedOn': 'Campaign switched on',
  'campaigns.switchedOff': 'Campaign switched off',
  'campaigns.deleteTitle': 'Delete this campaign?',
  'campaigns.deleteDescription': 'A campaign that is running cannot be deleted; switch it off or end it instead.',
  'campaigns.saved': 'Campaign saved',
  'campaigns.created': 'Campaign created',
  'campaigns.picker.title': 'What kind of campaign?',
  'campaigns.picker.description': 'The type cannot change once the campaign is created.',
  'campaigns.picker.SALE': 'A lower price on your plans for everyone, for a while.',
  'campaigns.picker.NEW_MEMBER': 'A lower price for people buying their first membership here.',
  'campaigns.picker.ANNOUNCEMENT': 'News on the website and in the member app, with a picture and a button. Prices stay the same.',
  'campaigns.picker.PROMO_CODE': 'A lower price for whoever types your code at checkout or tells it to the front desk. The code is never shown on the website.',
  'campaigns.picker.BONUS_DAYS': 'Extra days on every membership bought while it runs. Prices stay the same.',
  'campaigns.summary.withPicture': 'with a picture',
  'campaigns.summary.button': 'button “{label}”',
  'campaigns.summary.textOnly': 'text only',
  'campaigns.summary.nothing': 'no discount yet',
  'campaigns.summary.pct': '{pct}%',
  'campaigns.summary.range': '{min}–{max}%',
  'campaigns.summary.everyPlan': '{pct} off every plan',
  'campaigns.summary.plans.one': '{pct} off {count} plan',
  'campaigns.summary.plans.other': '{pct} off {count} plans',
  'campaigns.summary.firstMembership': 'first membership only',
  'campaigns.summary.legacyNewMembers': 'new members {pct}%',
  'campaigns.summary.code': 'Code {code}',
  'campaigns.summary.off': '{pct} off',
  'campaigns.summary.used': 'used {used}',
  'campaigns.summary.usedOf': 'used {used} of {limit}',
  'campaigns.summary.noBonus': 'no bonus days yet',
  'campaigns.summary.bonusEvery': '+{days} on memberships',
  'campaigns.summary.bonusPlans.one': '+{days} on {count} plan',
  'campaigns.summary.bonusPlans.other': '+{days} on {count} plans',
  'campaigns.badge.bonusDays.one': '+{count} day',
  'campaigns.badge.bonusDays.other': '+{count} days',
  'campaigns.builder.new.SALE': 'New sale',
  'campaigns.builder.new.NEW_MEMBER': 'New offer for new members',
  'campaigns.builder.new.ANNOUNCEMENT': 'New announcement',
  'campaigns.builder.new.PROMO_CODE': 'New promo code',
  'campaigns.builder.new.BONUS_DAYS': 'New bonus days',
  'campaigns.card.copy': 'Text',
  'campaigns.card.copyHint': 'Leave Georgian empty to reuse the English.',
  'campaigns.card.schedule': 'Schedule',
  'campaigns.card.announcement': 'Picture and button',
  'campaigns.card.discounts': 'Discounts',
  'campaigns.card.discountsHint.SALE': 'Everyone pays the lower price while the sale runs.',
  'campaigns.card.discountsHint.NEW_MEMBER': 'Only for people who have never held a membership here. When a sale also runs they pay whichever price is lower, never both.',
  'campaigns.card.discountsHint.PROMO_CODE': 'Only for whoever uses the code. When a sale or a new-member offer is lower they pay that price instead, never both.',
  'campaigns.card.code': 'Promo code',
  'campaigns.card.codeHint': 'Buyers type it at checkout, or the front desk enters it for them. It is never shown on the website.',
  'campaigns.card.bonus': 'Bonus days',
  'campaigns.card.bonusHint': 'Days added to every membership bought while the campaign runs. Prices stay the same, and session packages get none.',
  'campaigns.field.title': 'Title',
  'campaigns.field.titleHint': 'Shown on the banner.',
  'campaigns.field.details': 'Details',
  'campaigns.field.detailsHint': 'Optional line beside the title.',
  'campaigns.field.starts': 'Starts',
  'campaigns.field.startsHint': "In the gym's local time.",
  'campaigns.field.ends': 'Ends',
  'campaigns.field.endsHint': 'The last moment it runs.',
  'campaigns.field.announceDays': 'Announce days',
  'campaigns.field.announceDaysHint': 'How many days before the start the website announces it. Prices change only once it starts.',
  'campaigns.field.announceDaysHintNews': 'How many days before the start it shows, with its start date.',
  'campaigns.field.discount': 'Discount',
  'campaigns.field.discountHint': 'Applies to every plan without its own percentage.',
  'campaigns.field.newMembers': 'New members (banner only)',
  'campaigns.field.newMembersHint': 'Advertised on the banner but never charged. Set 0 to remove it and use an offer for new members instead.',
  'campaigns.field.titleHintCode': 'Your own name for it. The website never shows it.',
  'campaigns.field.detailsHintCode': 'Optional note for your team.',
  'campaigns.field.code': 'Code',
  'campaigns.field.codeHint': 'Letters, digits, - and _, 3 to 32 characters. Capital letters do not matter: autumn10 works for AUTUMN10.',
  'campaigns.field.usageLimit': 'Uses in all',
  'campaigns.field.usageLimitHint': 'Leave empty for no limit.',
  'campaigns.field.perMemberLimit': 'Uses per member',
  'campaigns.field.perMemberLimitHint': 'How many times one member can use it.',
  'campaigns.field.bonusDays': 'Bonus days',
  'campaigns.field.bonusDaysHint': 'Added to every plan without its own number of days.',
  'campaigns.field.image': 'Picture',
  'campaigns.field.imageHint': 'Optional. Shown beside the text.',
  'campaigns.field.ctaToggle': 'Add a button',
  'campaigns.field.ctaLabel': 'Button label',
  'campaigns.field.ctaHref': 'Link',
  'campaigns.field.ctaHrefHint': 'A page of the site (/contact), a section (#plans) or a full address (https://…).',
  'campaigns.isOn': 'Campaign is on',
  'campaigns.isOnHint': 'Switched off, it never shows and never changes a price.',
  'campaigns.overlap': 'These dates overlap {campaigns}. Only one sale applies at a time, and the one that started most recently wins.',
  'campaigns.anotherCampaign': 'another campaign',
  'campaigns.error.title': 'Give it a title.',
  'campaigns.error.range': 'It must end after it starts.',
  'campaigns.error.announceDays': 'Between 0 and 120 days.',
  'campaigns.error.noDiscount': 'Give it a discount above 0%, or switch it off to keep it as a draft.',
  'campaigns.error.percent': 'Between 0 and 100.',
  'campaigns.error.ctaLabel': 'Give the button a label.',
  'campaigns.error.ctaHref': 'Use /page, #section, https://…, mailto: or tel:.',
  'campaigns.error.code': 'Use 3 to 32 letters, digits, - or _.',
  'campaigns.error.usageLimit': 'A whole number from 1 to 1,000,000, or empty for no limit.',
  'campaigns.error.perMemberLimit': 'A whole number from 1 to 100.',
  'campaigns.error.bonusDays': 'Between 0 and 365 days.',
  'campaigns.error.noBonusDays': 'Give it some bonus days, or switch it off to keep it as a draft.',
  'admin.apiError.PROMO_CODE_TAKEN': 'Another promo code running at the same time already uses this code. Pick a different code or change the dates.',
  'campaigns.preview.title': 'Preview',
  'campaigns.preview.hint': 'As visitors will see it, in your brand colours.',
  'campaigns.preview.language': 'Preview language',
  'campaigns.preview.empty': 'Add a title to see the banner.',
  'campaigns.preview.emptyBonus': 'Add bonus days to see the banner.',
  'campaigns.preview.codeNote': 'A promo code never shows on the website or in the member app. Buyers type it at checkout, or the front desk enters it.',
  'campaigns.table.own': 'Own %',
  'campaigns.table.plan': 'Plan',
  'campaigns.table.price': 'Price',
  'campaigns.table.pct': '%',
  'campaigns.table.final': 'Final',
  'campaigns.table.ownFor': 'Own percentage for {plan}',
  'campaigns.table.defaultPct': '{pct}% (default)',
  'campaigns.table.noPlans': 'No plans yet.',
  'campaigns.planPercentage': '{plan} percentage',
  'campaigns.table.length': 'Length',
  'campaigns.table.bonus': 'Bonus days',
  'campaigns.table.runs': 'Runs for',
  'campaigns.table.bonusFor': 'Bonus days for {plan}',
  'campaigns.table.bonusHint': 'Leave a plan blank to use the default. 0 leaves that plan out.',

  'banner.label': 'Offers and news',
  'banner.sale': 'Offer',
  'banner.newMembers': 'New members',
  'banner.news': 'News',
  'banner.bonus': 'Bonus days',
  'banner.pctOff': '{pct}% off',
  'banner.upToPctOff': 'Up to {pct}% off',
  'banner.starts': 'Starts {date}',
  'banner.until': 'Until {date}',
  'banner.legacyNewMembers': 'New members: {pct}% off',
  'banner.bonusEvery.one': '+{count} day on every membership bought until {date}',
  'banner.bonusEvery.other': '+{count} days on every membership bought until {date}',
  'banner.bonusUpTo.one': 'Up to +{count} day on memberships bought until {date}',
  'banner.bonusUpTo.other': 'Up to +{count} days on memberships bought until {date}',

  'plans.newMemberPrice': 'New-member price',
  'plans.salePrice': 'Sale price',
  'plans.promoPrice': 'Promo code price',
  'plans.bonusDays.one': '+{count} bonus day',
  'plans.bonusDays.other': '+{count} bonus days',
  'plans.promo.label': 'Have a promo code?',
  'plans.promo.placeholder': 'Enter your code',
  'plans.promo.apply': 'Apply',
  'plans.promo.remove': 'Remove',
  'plans.promo.applied': 'Code {code} applied.',
  'plans.promo.notBetter': 'This code gives no better price for this plan than the one shown.',
  'plans.promo.failed': 'The code could not be checked. Try again.',
  'promo.reason.UNKNOWN': 'We do not know this code. Check how it is spelled.',
  'promo.reason.NOT_LIVE': 'This code is not running right now.',
  'promo.reason.USED_UP': 'This code has been used up.',
  'promo.reason.ALREADY_USED': 'This code has already been used as many times as one member may use it.',
  'promo.reason.NOT_FOR_PLAN': 'This code gives no discount on this plan.',
  'sell.newMemberPrice': 'New-member price: {pct}% off {price}',
  'sell.salePrice': 'Sale price: {pct}% off {price}',
  'sell.promoPrice': 'Promo code price: {pct}% off {price}',
  'sell.promoCode': 'Promo code',
};

export const ka: Record<keyof typeof en, string> = {
  'campaigns.title': 'აქციები',
  'campaigns.description': 'ფასდაკლებები, შეთავაზებები ახალი წევრებისთვის, პრომო კოდები, ბონუს დღეები და განცხადებები, თითოეული საკუთარი განრიგით. ვებსაიტი აჩვენებს იმას, რაც ახლა მიმდინარეობს; პრომო კოდი მხოლოდ მაშინ მოქმედებს, როცა მას შეიყვანენ.',
  'campaigns.new': 'ახალი აქცია',
  'campaigns.empty': 'აქციები არ არის',
  'campaigns.emptyHint': 'მოაწყვეთ ფასდაკლება, შესთავაზეთ ახალ წევრებს დაბალი ფასი ან გამოაქვეყნეთ სიახლე ვებსაიტზე და წევრის კაბინეტში.',
  'campaigns.emptyFiltered': 'ამ ფილტრებს არცერთი აქცია არ შეესაბამება.',
  'campaigns.create': 'აქციის შექმნა',
  'campaigns.untitled': 'უსათაურო',
  'campaigns.pill.none': 'ვებსაიტზე აქცია არ არის',
  'campaigns.pill.live': 'ვებსაიტზე ახლა: {title}',
  'campaigns.pill.announced': 'გამოცხადებულია: {title} · იწყება {date}',
  'campaigns.filter.kind': 'ტიპი',
  'campaigns.filter.status': 'სტატუსი',
  'campaigns.filter.all': 'ყველა',
  'campaigns.filter.SALE': 'ფასდაკლებები',
  'campaigns.filter.NEW_MEMBER': 'შეთავაზებები ახალი წევრებისთვის',
  'campaigns.filter.ANNOUNCEMENT': 'განცხადებები',
  'campaigns.filter.PROMO_CODE': 'პრომო კოდები',
  'campaigns.filter.BONUS_DAYS': 'ბონუს დღეები',
  'campaigns.status.all': 'ყველა',
  'campaigns.status.live': 'მიმდინარე',
  'campaigns.status.upcoming': 'მომავალი',
  'campaigns.status.ended': 'დასრულებული',
  'campaigns.status.disabled': 'გამორთული',
  'campaigns.kind.SALE': 'ფასდაკლება',
  'campaigns.kind.NEW_MEMBER': 'შეთავაზება ახალი წევრისთვის',
  'campaigns.kind.ANNOUNCEMENT': 'განცხადება',
  'campaigns.kind.PROMO_CODE': 'პრომო კოდი',
  'campaigns.kind.BONUS_DAYS': 'ბონუს დღეები',
  'campaigns.announcedFrom': 'ცხადდება {date}-დან',
  'campaigns.duplicate': 'დუბლირება',
  'campaigns.sms.open': 'SMS-ით გაგზავნა',
  'campaigns.sms.title': '„{title}“ SMS-ით',
  'campaigns.sms.description': 'შეთავაზება SMS-ით მიდის მხოლოდ იმ წევრებთან, ვინც დათანხმდა შეთავაზებების მიღებას SMS-ით, თითო აქციაზე ერთხელ, მათ ენაზე.',
  'campaigns.sms.audience': 'ვინ მიიღებს',
  'campaigns.sms.audience.ALL': 'ყველა, ვინც დათანხმდა',
  'campaigns.sms.audience.ACTIVE': 'წევრები აქტიური აბონემენტით',
  'campaigns.sms.audience.LAPSED': 'წევრები, რომელთა აბონემენტი დასრულდა',
  'campaigns.sms.audience.SEGMENT': 'სეგმენტი',
  'campaigns.sms.segment': 'სეგმენტი',
  'campaigns.sms.chooseSegment': 'აირჩიეთ სეგმენტი',
  'campaigns.sms.noSegments': 'დარბაზს სეგმენტები ჯერ არ აქვს.',
  'campaigns.sms.buildSegment': 'შექმენით',
  'campaigns.sms.segmentConsent': 'მიიღებენ მხოლოდ სეგმენტის ის წევრები, ვინც დათანხმდა შეთავაზებებს SMS-ით.',
  'campaigns.sms.segmentDeleted': 'წაშლილი სეგმენტი',
  'campaigns.sms.textEn': 'ტექსტი ინგლისურად',
  'campaigns.sms.textKa': 'ტექსტი ქართულად',
  'campaigns.sms.parts': '{characters} სიმბოლო დარბაზის სახელითა და უარის თქმის ხაზით · {parts} SMS ნაწილი',
  'campaigns.sms.reach': 'მიიღებს {count} წევრი: {en} ინგლისურად, {ka} ქართულად.',
  'campaigns.sms.alreadyTexted': '{count} წევრს ეს აქცია უკვე მიღებული აქვს და გამოტოვებულია.',
  'campaigns.sms.totalParts': 'სულ დაახლოებით {parts} SMS ნაწილი, დარბაზის smsoffice.ge ბალანსიდან.',
  'campaigns.sms.rules': 'SMS-ები იგზავნება 10:00-დან 21:00-მდე დარბაზის დროით; სხვა დროს ელოდება. თუ წევრი მანამდე უარს იტყვის, არ მიიღებს.',
  'campaigns.sms.blocker.NO_SMS_ACCOUNT': 'დარბაზს ჯერ არ აქვს მომუშავე SMS ანგარიში.',
  'campaigns.sms.blocker.NO_OPT_OUT_LINE': 'შეიყვანეთ უარის თქმის ხაზი, რომელიც smsoffice.ge-მ მისცა თქვენს გამგზავნს; ყველა შეთავაზება მით უნდა სრულდებოდეს.',
  'campaigns.sms.openIntegrations': 'ინტეგრაციების გახსნა',
  'campaigns.sms.send': 'გაგზავნა {count} წევრთან',
  'campaigns.sms.confirmTitle': 'გავუგზავნოთ SMS {count} წევრს ახლა?',
  'campaigns.sms.confirmDescription': 'ჩამოიჭრება დაახლოებით {parts} SMS ნაწილი. გაგზავნილ SMS-ს ვერ დააბრუნებთ.',
  'campaigns.sms.confirm': 'SMS-ების გაგზავნა',
  'campaigns.sms.queued': '{count} SMS რიგშია',
  'campaigns.sms.history': 'ადრე გაგზავნილი',
  'campaigns.sms.when': 'როდის',
  'campaigns.sms.by': 'ვინ',
  'campaigns.sms.counts': 'ელოდება · გაიგზავნა · ვერ გაიგზავნა',
  'campaigns.sms.countsValue': '{queued} · {sent} · {failed}',
  'campaigns.email.open': 'ელფოსტით გაგზავნა',
  'campaigns.email.title': '„{title}“ ელფოსტით',
  'campaigns.email.description': 'შეთავაზება ელფოსტით მიდის მხოლოდ იმ წევრებთან, ვინც დათანხმდა შეთავაზებების მიღებას ელფოსტით, თითო აქციაზე ერთხელ, მათ ენაზე.',
  'campaigns.email.audience': 'ვინ მიიღებს',
  'campaigns.email.audience.ALL': 'ყველა, ვინც დათანხმდა',
  'campaigns.email.audience.ACTIVE': 'წევრები აქტიური აბონემენტით',
  'campaigns.email.audience.LAPSED': 'წევრები, რომელთა აბონემენტი დასრულდა',
  'campaigns.email.audience.SEGMENT': 'სეგმენტი',
  'campaigns.email.segment': 'სეგმენტი',
  'campaigns.email.chooseSegment': 'აირჩიეთ სეგმენტი',
  'campaigns.email.noSegments': 'დარბაზს სეგმენტები ჯერ არ აქვს.',
  'campaigns.email.buildSegment': 'შექმენით',
  'campaigns.email.segmentConsent': 'მიიღებენ მხოლოდ სეგმენტის ის წევრები, ვინც დათანხმდა შეთავაზებებს ელფოსტით.',
  'campaigns.email.segmentDeleted': 'წაშლილი სეგმენტი',
  'campaigns.email.subjectEn': 'თემა ინგლისურად',
  'campaigns.email.subjectKa': 'თემა ქართულად',
  'campaigns.email.textEn': 'წერილის ტექსტი ინგლისურად',
  'campaigns.email.textKa': 'წერილის ტექსტი ქართულად',
  'campaigns.email.subjectNeeded': 'მიუთითეთ წერილის თემა ამ ენაზე ან წაშალეთ მისი ტექსტი.',
  'campaigns.email.footerNote': 'ყოველი წერილი მთავრდება ხაზით, რომელიც ხსნის, რატომ იღებს წევრი მას, და ბმულით, რომლითაც წევრი ელფოსტით შეთავაზებებს წყვეტს.',
  'campaigns.email.reach': 'მიიღებს {count} წევრი: {en} ინგლისურად, {ka} ქართულად.',
  'campaigns.email.alreadyEmailed': '{count} წევრს ეს აქცია უკვე მიღებული აქვს და გამოტოვებულია.',
  'campaigns.email.blocker.NO_EMAIL_ACCOUNT': 'ჯერ უნდა დაკავშირდეს და შემოწმდეს დარბაზის საკუთარი ელფოსტის ანგარიში. შეთავაზებები Bulk-ის გამგზავნიდან არასოდეს იგზავნება.',
  'campaigns.email.blocker.PRACTICE_GYM': 'სავარჯიშო დარბაზი შეთავაზებებს ელფოსტით არასოდეს აგზავნის; მისი წევრები გამოგონილია.',
  'campaigns.email.openIntegrations': 'ინტეგრაციების გახსნა',
  'campaigns.email.send': 'გაგზავნა {count} წევრთან',
  'campaigns.email.confirmTitle': 'გავუგზავნოთ წერილი {count} წევრს ახლა?',
  'campaigns.email.confirmDescription': 'გაგზავნილ წერილს ვერ დააბრუნებთ.',
  'campaigns.email.confirm': 'წერილების გაგზავნა',
  'campaigns.email.queued': '{count} წერილი რიგშია',
  'campaigns.email.history': 'ადრე გაგზავნილი',
  'campaigns.email.when': 'როდის',
  'campaigns.email.subject': 'თემა',
  'campaigns.email.by': 'ვინ',
  'campaigns.email.counts': 'ელოდება · გაიგზავნა · ვერ გაიგზავნა',
  'campaigns.email.countsValue': '{queued} · {sent} · {failed}',
  'campaigns.duplicated': 'ასლი შეიქმნა და გამორთულია. მიუთითეთ თარიღები და შემდეგ ჩართეთ.',
  'campaigns.deleted': 'აქცია წაიშალა',
  'campaigns.switchedOn': 'აქცია ჩაირთო',
  'campaigns.switchedOff': 'აქცია გამოირთო',
  'campaigns.deleteTitle': 'წავშალოთ ეს აქცია?',
  'campaigns.deleteDescription': 'მიმდინარე აქციის წაშლა შეუძლებელია; ამის ნაცვლად გამორთეთ ან დაასრულეთ ის.',
  'campaigns.saved': 'აქცია შენახულია',
  'campaigns.created': 'აქცია შეიქმნა',
  'campaigns.picker.title': 'როგორი აქცია გსურთ?',
  'campaigns.picker.description': 'შექმნის შემდეგ აქციის ტიპი ვეღარ შეიცვლება.',
  'campaigns.picker.SALE': 'დროებით დაბალი ფასი პაკეტებზე ყველასთვის.',
  'campaigns.picker.NEW_MEMBER': 'დაბალი ფასი მათთვის, ვინც აქ პირველ აბონემენტს ყიდულობს.',
  'campaigns.picker.ANNOUNCEMENT': 'სიახლე ვებსაიტზე და წევრის კაბინეტში, სურათითა და ღილაკით. ფასები არ იცვლება.',
  'campaigns.picker.PROMO_CODE': 'დაბალი ფასი მისთვის, ვინც გადახდისას თქვენს კოდს შეიყვანს ან რეცეფციაზე დაასახელებს. კოდი ვებსაიტზე არასოდეს ჩანს.',
  'campaigns.picker.BONUS_DAYS': 'დამატებითი დღეები ყველა აბონემენტზე, რომელიც აქციის მიმდინარეობისას შეიძინება. ფასები არ იცვლება.',
  'campaigns.summary.withPicture': 'სურათით',
  'campaigns.summary.button': 'ღილაკი „{label}“',
  'campaigns.summary.textOnly': 'მხოლოდ ტექსტი',
  'campaigns.summary.nothing': 'ფასდაკლება ჯერ არ არის',
  'campaigns.summary.pct': '{pct}%',
  'campaigns.summary.range': '{min}–{max}%',
  'campaigns.summary.everyPlan': '{pct} ფასდაკლება ყველა პაკეტზე',
  'campaigns.summary.plans.one': '{pct} ფასდაკლება {count} პაკეტზე',
  'campaigns.summary.plans.other': '{pct} ფასდაკლება {count} პაკეტზე',
  'campaigns.summary.firstMembership': 'მხოლოდ პირველ აბონემენტზე',
  'campaigns.summary.legacyNewMembers': 'ახალი წევრები {pct}%',
  'campaigns.summary.code': 'კოდი {code}',
  'campaigns.summary.off': '{pct} ფასდაკლება',
  'campaigns.summary.used': 'გამოყენებულია {used}-ჯერ',
  'campaigns.summary.usedOf': 'გამოყენებულია {limit}-დან {used}',
  'campaigns.summary.noBonus': 'ბონუს დღეები ჯერ არ არის',
  'campaigns.summary.bonusEvery': '+{days} აბონემენტებზე',
  'campaigns.summary.bonusPlans.one': '+{days} {count} პაკეტზე',
  'campaigns.summary.bonusPlans.other': '+{days} {count} პაკეტზე',
  'campaigns.badge.bonusDays.one': '+{count} დღე',
  'campaigns.badge.bonusDays.other': '+{count} დღე',
  'campaigns.builder.new.SALE': 'ახალი ფასდაკლება',
  'campaigns.builder.new.NEW_MEMBER': 'ახალი შეთავაზება ახალი წევრებისთვის',
  'campaigns.builder.new.ANNOUNCEMENT': 'ახალი განცხადება',
  'campaigns.builder.new.PROMO_CODE': 'ახალი პრომო კოდი',
  'campaigns.builder.new.BONUS_DAYS': 'ახალი ბონუს დღეები',
  'campaigns.card.copy': 'ტექსტი',
  'campaigns.card.copyHint': 'თუ ქართულს ცარიელს დატოვებთ, გამოჩნდება ინგლისური ტექსტი.',
  'campaigns.card.schedule': 'განრიგი',
  'campaigns.card.announcement': 'სურათი და ღილაკი',
  'campaigns.card.discounts': 'ფასდაკლებები',
  'campaigns.card.discountsHint.SALE': 'ფასდაკლების მიმდინარეობისას ყველა დაბალ ფასს იხდის.',
  'campaigns.card.discountsHint.NEW_MEMBER': 'მხოლოდ მათთვის, ვისაც აქ აბონემენტი არასოდეს ჰქონია. თუ ამავდროულად ფასდაკლებაც მიმდინარეობს, ისინი უფრო დაბალ ფასს იხდიან და ორი ფასდაკლება ერთად არ ვრცელდება.',
  'campaigns.card.discountsHint.PROMO_CODE': 'მხოლოდ მათთვის, ვინც კოდს გამოიყენებს. თუ ფასდაკლება ან შეთავაზება ახალი წევრისთვის უფრო დაბალ ფასს იძლევა, იმ ფასს იხდიან და ორი ფასდაკლება ერთად არ ვრცელდება.',
  'campaigns.card.code': 'პრომო კოდი',
  'campaigns.card.codeHint': 'მყიდველი მას გადახდისას შეიყვანს, ან რეცეფცია შეიყვანს მის მაგივრად. ვებსაიტზე ის არასოდეს ჩანს.',
  'campaigns.card.bonus': 'ბონუს დღეები',
  'campaigns.card.bonusHint': 'ემატება ყველა აბონემენტს, რომელიც აქციის მიმდინარეობისას შეიძინება. ფასები არ იცვლება, სესიების პაკეტებს კი ბონუსი არ ეძლევა.',
  'campaigns.field.title': 'სათაური',
  'campaigns.field.titleHint': 'ჩანს ბანერზე.',
  'campaigns.field.details': 'დეტალები',
  'campaigns.field.detailsHint': 'არასავალდებულო სტრიქონი სათაურის გვერდით.',
  'campaigns.field.starts': 'იწყება',
  'campaigns.field.startsHint': 'დარბაზის ადგილობრივი დროით.',
  'campaigns.field.ends': 'მთავრდება',
  'campaigns.field.endsHint': 'ბოლო მომენტი, როცა მოქმედებს.',
  'campaigns.field.announceDays': 'ანონსის დღეები',
  'campaigns.field.announceDaysHint': 'დაწყებამდე რამდენი დღით ადრე გამოაცხადებს მას ვებსაიტი. ფასები მხოლოდ დაწყების შემდეგ იცვლება.',
  'campaigns.field.announceDaysHintNews': 'დაწყებამდე რამდენი დღით ადრე გამოჩნდება, დაწყების თარიღით.',
  'campaigns.field.discount': 'ფასდაკლება',
  'campaigns.field.discountHint': 'ვრცელდება ყველა პაკეტზე, რომელსაც საკუთარი პროცენტი არ აქვს.',
  'campaigns.field.newMembers': 'ახალი წევრები (მხოლოდ ბანერზე)',
  'campaigns.field.newMembersHint': 'ჩანს ბანერზე, მაგრამ ფასზე არ მოქმედებს. წასაშლელად მიუთითეთ 0 და ამის ნაცვლად გამოიყენეთ შეთავაზება ახალი წევრებისთვის.',
  'campaigns.field.titleHintCode': 'თქვენი საკუთარი სახელი. ვებსაიტზე არ ჩანს.',
  'campaigns.field.detailsHintCode': 'არასავალდებულო შენიშვნა გუნდისთვის.',
  'campaigns.field.code': 'კოდი',
  'campaigns.field.codeHint': 'ასოები, ციფრები, - და _, 3-დან 32 სიმბოლომდე. დიდი და პატარა ასოები არ განირჩევა: autumn10 ემთხვევა AUTUMN10-ს.',
  'campaigns.field.usageLimit': 'სულ გამოყენება',
  'campaigns.field.usageLimitHint': 'შეზღუდვის გარეშე დატოვეთ ცარიელი.',
  'campaigns.field.perMemberLimit': 'გამოყენება თითო წევრზე',
  'campaigns.field.perMemberLimitHint': 'რამდენჯერ შეუძლია ერთ წევრს მისი გამოყენება.',
  'campaigns.field.bonusDays': 'ბონუს დღეები',
  'campaigns.field.bonusDaysHint': 'ემატება ყველა პაკეტს, რომელსაც საკუთარი დღეები არ აქვს.',
  'campaigns.field.image': 'სურათი',
  'campaigns.field.imageHint': 'არასავალდებულო. ჩანს ტექსტის გვერდით.',
  'campaigns.field.ctaToggle': 'ღილაკის დამატება',
  'campaigns.field.ctaLabel': 'ღილაკის წარწერა',
  'campaigns.field.ctaHref': 'ბმული',
  'campaigns.field.ctaHrefHint': 'საიტის გვერდი (/contact), სექცია (#plans) ან სრული მისამართი (https://…).',
  'campaigns.isOn': 'აქცია ჩართულია',
  'campaigns.isOnHint': 'გამორთული აქცია არ ჩანს და ფასს არ ცვლის.',
  'campaigns.overlap': 'ეს თარიღები ემთხვევა: {campaigns}. ერთდროულად მხოლოდ ერთი ფასდაკლება მოქმედებს და უპირატესობა ბოლოს დაწყებულს აქვს.',
  'campaigns.anotherCampaign': 'სხვა აქცია',
  'campaigns.error.title': 'მიუთითეთ სათაური.',
  'campaigns.error.range': 'დასრულების დრო დაწყების შემდეგ უნდა იყოს.',
  'campaigns.error.announceDays': '0-დან 120 დღემდე.',
  'campaigns.error.noDiscount': 'მიუთითეთ 0%-ზე მეტი ფასდაკლება ან გამორთეთ, რომ მონახაზად შეინახოთ.',
  'campaigns.error.percent': '0-დან 100-მდე.',
  'campaigns.error.ctaLabel': 'მიუთითეთ ღილაკის წარწერა.',
  'campaigns.error.ctaHref': 'გამოიყენეთ /გვერდი, #სექცია, https://…, mailto: ან tel:.',
  'campaigns.error.code': 'გამოიყენეთ 3-დან 32-მდე ასო, ციფრი, - ან _.',
  'campaigns.error.usageLimit': 'მთელი რიცხვი 1-დან 1 000 000-მდე ან ცარიელი ველი, თუ შეზღუდვა არ გინდათ.',
  'campaigns.error.perMemberLimit': 'მთელი რიცხვი 1-დან 100-მდე.',
  'campaigns.error.bonusDays': '0-დან 365 დღემდე.',
  'campaigns.error.noBonusDays': 'მიუთითეთ ბონუს დღეები ან გამორთეთ, რომ მონახაზად შეინახოთ.',
  'admin.apiError.PROMO_CODE_TAKEN': 'ამავე დროს მოქმედი სხვა პრომო კოდი ამ კოდს უკვე იყენებს. აირჩიეთ სხვა კოდი ან შეცვალეთ თარიღები.',
  'campaigns.preview.title': 'გადახედვა',
  'campaigns.preview.hint': 'ისე, როგორც ვიზიტორები ნახავენ, თქვენი ბრენდის ფერებში.',
  'campaigns.preview.language': 'გადახედვის ენა',
  'campaigns.preview.empty': 'ბანერის სანახავად მიუთითეთ სათაური.',
  'campaigns.preview.emptyBonus': 'ბანერის სანახავად მიუთითეთ ბონუს დღეები.',
  'campaigns.preview.codeNote': 'პრომო კოდი ვებსაიტზე და წევრის კაბინეტში არასოდეს ჩანს. მყიდველი მას გადახდისას შეიყვანს, ან რეცეფცია შეიყვანს.',
  'campaigns.table.own': 'საკუთარი %',
  'campaigns.table.plan': 'პაკეტი',
  'campaigns.table.price': 'ფასი',
  'campaigns.table.pct': '%',
  'campaigns.table.final': 'საბოლოო',
  'campaigns.table.ownFor': '{plan}: საკუთარი პროცენტი',
  'campaigns.table.defaultPct': '{pct}% (ნაგულისხმევი)',
  'campaigns.table.noPlans': 'პაკეტები ჯერ არ არის.',
  'campaigns.planPercentage': '{plan}: პროცენტი',
  'campaigns.table.length': 'ხანგრძლივობა',
  'campaigns.table.bonus': 'ბონუს დღეები',
  'campaigns.table.runs': 'ჯამში',
  'campaigns.table.bonusFor': '{plan}: ბონუს დღეები',
  'campaigns.table.bonusHint': 'ცარიელი ველი ნაგულისხმევ რიცხვს იყენებს. 0 პაკეტს ბონუსიდან გამორიცხავს.',

  'banner.label': 'შეთავაზებები და სიახლეები',
  'banner.sale': 'შეთავაზება',
  'banner.newMembers': 'ახალი წევრები',
  'banner.news': 'სიახლე',
  'banner.bonus': 'ბონუს დღეები',
  'banner.pctOff': '{pct}% ფასდაკლება',
  'banner.upToPctOff': '{pct}%-მდე ფასდაკლება',
  'banner.starts': 'იწყება {date}',
  'banner.until': '{date}-მდე',
  'banner.legacyNewMembers': 'ახალი წევრებისთვის: {pct}% ფასდაკლება',
  'banner.bonusEvery.one': '{date}-მდე შეძენილ ყველა აბონემენტს +{count} ბონუს დღე ემატება',
  'banner.bonusEvery.other': '{date}-მდე შეძენილ ყველა აბონემენტს +{count} ბონუს დღე ემატება',
  'banner.bonusUpTo.one': '{date}-მდე შეძენილ აბონემენტებს ბონუსად +{count} დღემდე ემატება',
  'banner.bonusUpTo.other': '{date}-მდე შეძენილ აბონემენტებს ბონუსად +{count} დღემდე ემატება',

  'plans.newMemberPrice': 'ახალი წევრის ფასი',
  'plans.salePrice': 'ფასდაკლებით',
  'plans.promoPrice': 'ფასი პრომო კოდით',
  'plans.bonusDays.one': '+{count} ბონუს დღე',
  'plans.bonusDays.other': '+{count} ბონუს დღე',
  'plans.promo.label': 'გაქვთ პრომო კოდი?',
  'plans.promo.placeholder': 'შეიყვანეთ კოდი',
  'plans.promo.apply': 'გამოყენება',
  'plans.promo.remove': 'მოხსნა',
  'plans.promo.applied': 'კოდი {code} გამოყენებულია.',
  'plans.promo.notBetter': 'ეს კოდი ამ პაკეტზე ნაჩვენებზე უკეთეს ფასს არ იძლევა.',
  'plans.promo.failed': 'კოდის შემოწმება ვერ მოხერხდა. სცადეთ ხელახლა.',
  'promo.reason.UNKNOWN': 'ეს კოდი უცნობია. შეამოწმეთ, სწორად არის თუ არა აკრეფილი.',
  'promo.reason.NOT_LIVE': 'ეს კოდი ახლა არ მოქმედებს.',
  'promo.reason.USED_UP': 'ამ კოდის გამოყენების ლიმიტი ამოწურულია.',
  'promo.reason.ALREADY_USED': 'ეს კოდი უკვე გამოყენებულია იმდენჯერ, რამდენჯერაც ერთ წევრს შეუძლია.',
  'promo.reason.NOT_FOR_PLAN': 'ეს კოდი ამ პაკეტზე ფასდაკლებას არ იძლევა.',
  'sell.newMemberPrice': 'ახალი წევრის ფასი: {price}-ზე {pct}% ფასდაკლება',
  'sell.salePrice': 'ფასდაკლება: {price}-ზე {pct}%',
  'sell.promoPrice': 'ფასი პრომო კოდით: {price}-ზე {pct}% ფასდაკლება',
  'sell.promoCode': 'პრომო კოდი',
};
